export var overwriteAccessors = function overwriteAccessors(object, property, createGetter, createSetter) {
  var prototype = Object.getPrototypeOf(object);
  while (!prototype.hasOwnProperty(property)) {
    prototype = Object.getPrototypeOf(prototype);
  }
  var _Object$getOwnPropert = Object.getOwnPropertyDescriptor(prototype, property),
    get = _Object$getOwnPropert.get,
    set = _Object$getOwnPropert.set;
  Object.defineProperty(object, property, {
    get: createGetter(get),
    set: createSetter(set)
  });
};